@if (
    !dataService.error() && !optionListService.dataLoading() && !depositService.dataLoading() && !userDataService.dataLoading() && depositAvailable
) {
    @if (depositService.showODpopUp()) {
        <app-od-popup />
    } @else {
        <app-deposit />
    }
}
